<template>
  <f7-page no-toolbar no-navbar no-swipeback login-screen>
    <f7-login-screen-title>請先登入 Please Login</f7-login-screen-title>
    <f7-list form>
      <f7-list-input
        label="用戶名稱 Username"
        type="text"
        placeholder="請輸入用戶名稱 Username"
        :value="username"
        @input="username = $event.target.value"
      ></f7-list-input>
      <f7-list-input
        label="密碼 Password"
        type="password"
        placeholder="請輸入密碼 Password"
        :value="password"
        @input="password = $event.target.value"
      ></f7-list-input>
    </f7-list>
    <f7-list>
      <f7-list-button @click="signIn">登入 Login</f7-list-button>
    </f7-list>
  </f7-page>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    username: '',
    password: '',
  }),

  mounted() {
    axios.get('/api/user')
      .then(() => {
        this.$nextTick(() => {
          this.$f7router.navigate('/', {reloadAll: true})
        })
      })
      .catch(() => {})
  },

  methods: {
    signIn() {
      axios.get('/sanctum/csrf-cookie') .then(() => {
        axios
          .post('/login', {
            username: this.username,
            password: this.password
          })
          .then(() => {
            this.$f7router.navigate('/', {reloadAll: true})
          })
          .catch(() => {
            this.$f7.dialog.alert('用戶名稱或密碼錯誤')
          })
      })
      // const self = this;
      // const app = self.$f7;
      // const router = self.$f7router;
      // app.dialog.alert(`Username: ${self.username}<br>Password: ${self.password}`, () => {
      //   router.back();
      // });
    },
  },
}
</script>
